import React from 'react';
import { StarIcon } from 'lucide-react';
import { Container } from './ui/Container';
export function SocialProofBar() {
  return <section className="border-y border-mp-lime/40 bg-[#080d11] py-6 md:py-7" data-id="element-256" data-mp="2erz7iikhhkw1">
      <Container className="flex flex-col items-center gap-2 text-center" data-id="element-257" data-mp="29vh3jkwz9qkr">
        <div className="flex items-center gap-2" data-id="element-258" data-mp="25tds2wab6lzh">
          <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-259" data-mp="25uovguzudrq2">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-mp-lime text-mp-lime" data-id="element-260" data-mp="2xk0c81jxw5dd" data-mpi={i} />)}
          </div>
          <span className="font-heading text-sm uppercase tracking-wide text-mp-white md:text-base" data-id="element-261" data-mp="2ti6h08sijtkl">
            4,9/5 · +200 monitores activos en España
          </span>
        </div>
        <p className="max-w-[600px] text-xs italic leading-relaxed text-mp-gray md:text-sm" data-id="element-262" data-mp="1i39ogox4em8h">
          "El Semáforo de Correcciones solo ya vale lo que cuesta el manual entero." — Pablo C., monitor · Murcia
        </p>
      </Container>
    </section>;
}